<template lang="pug">
  b-container.content-wrap(fluid :class="{ 'is-mobile': isMobile }")
    b-row.mb-2
      b-col.page-wrap(cols="12")
        div.page-header(slot="header")
          b-container.d-flex.justify-content-between(fluid)
            span.page-title {{$t('management_page.user_remote_control_history')}}

    b-row.search-form
      b-col.mmb-10(cols="12" lg="2")
        b-form-select(v-model="form.date_type" :options="selectOptions.date" size="sm")
      b-col.mmb-10(cols="6" lg="2")
        b-form-datepicker(
          v-model="range.start"
          :bootstrap-styling="true"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="search"
        )
      b-col.mmb-10(cols="6" lg="2")
        b-form-datepicker(
          v-model="range.end"
          :bootstrap-styling="true"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="search"
        )
      b-col.mmb-10(cols="12" lg="4")
        b-input-group
          b-input-group-prepend
            b-form-select.mr-2(v-model="form.search_key" :options="selectOptions.list" size="sm" @change="changeSearchSelect")
          b-form-input.mr-2(v-if="selectInput.type === 'keyword'" v-model="form.search_value" size="sm" @keyup.enter="search")
          b-form-select.mr-2(v-if="selectInput.type === 'select'" v-model="form.search_value" :options="selectInput.list" size="sm")
          b-input-group-append
            b-btn(size="sm" @click="search") {{$t('search')}}

      b-col.right-btns
        b-btn.ml-2.view-mode-button(size="sm", :disabled="excelLoaded" @click="downloadExcel")
          img.mr-1(:src="`${AppState.Path.image}/icons/excel-icon.svg`" style="height: 0.9rem; vertical-align: middle;")
          span(v-if="!excelLoaded") {{$t('excel_button')}}
          span(v-else) Download...
    
    b-card.table-card
      b-table(
        ref="userTable"
        :fields="tableData.fields"
        :items="fetchList"
        :current-page="tableData.pagination.current"
        :per-page="tableData.pagination.limit"
        :empty-text="$t('no-content')"
        tbody-class="lmm-table-body"
        sort-by="start_time"
        :sort-desc="true"
        show-empty
        responsive
      )
        //- body
        template(v-slot:cell(start_time)="row")
          span {{ row.item.start_time | moment('YY-MM-DD HH:mm') }}
        
        template(v-slot:cell(end_time)="row")
          span {{ row.item.end_time | moment('YY-MM-DD HH:mm') }}

        template(v-slot:cell(requester_id)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.requester_pk}}") {{row.item.requester_id}}
        
        template(v-slot:cell(requester_name)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.requester_pk}}") {{row.item.requester_name}}
        
        template(v-slot:cell(host_os_id)="row")
          span {{ row.item.host_os_id | osPrint }}
        
        template(v-slot:cell(viewer_os_id)="row")
          span {{ row.item.viewer_os_id | osPrint }}
        
        template(v-slot:cell(record_file_path)="row")
          b-link(v-if="row.item.record_file_path" @click="openVideo(row.item.record_file_path)") O
          span(v-else) X
        
        template(v-slot:cell(flag_security_agreement)="row")
          b-link(v-if="row.item.flag_security_agreement" @click="openContract(row.item)") O
          span(v-else) X

    //- pagination
    .pagination-wrap
      div
        b-form-select(
          size="sm"
          v-model="tableData.pagination.limit"
          :options="tableData.pagination.perOptions"
        )
      b-pagination(
        size="sm"
        v-model="tableData.pagination.current"
        :total-rows="tableData.pagination.total"
        :per-page="tableData.pagination.limit"
        class="my-0 float-right"
      )

    dialog-contract(:show.sync="showContract" :form="contractForm" :isAdd="false")
</template>

<script>
import { AnalysticAPI, ManagementAPI, SecurityAgreementAPI, GetMgridAPI} from "@/api"
import Switches from "vue-switches"
import _ from "lodash"
import moment from "moment"
import { getCurrentLanguage } from "@/i18n"
import * as datePickerLocale from "vuejs-datepicker/dist/locale"
import DialogContract from "@/components/management/function-settings/components/dialog/dialogSettingContract/form.vue"

export default {
  components: {
    Switches,
    DialogContract,
  },
  computed: {
    selectInput() {
      return _.find(this.selectOptions.list, { value: this.form.search_key })
    },
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
    kindFilter() {
      return (value) => {
        switch (value) {
          case 0:
            return this.$t('prior')
          case 1:
            return this.$t('post')
          case 2:
            return this.$t('exception')
          default:
            return "-"
        }
      }
    },
  },
  filters: {
    osPrint(value) {
      return {
        0: "UNKNOWN",
        1: "Windows",
        2: "Linux",
        3: "OS_X",
        4: "Android",
        5: "iOS",
      }[value]
    },
  },
  data() {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      showContract: false,
      contractForm: {
        security_agreement_version: "",
        content: "",
      },
      contractList: [],

      range: {
        start: moment()
          .add(-14, "days")
          .toDate(),
        end: moment().toDate(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()],
      },
      form: {
        date_type: "start_time",
        search_key: "device_name",
        search_value: "",
      },
      selectOptions: {
        date: [
          { text: this.$t('start_datetime'), value: "start_time" },
          { text: this.$t('end_datetime'), value: "end_time" },
        ],
        list: [
          { text: this.$t('ID'), value: "requester_id", type: "keyword" },
          { text: this.$t('account-manage'), value: "requester_name", type: "keyword" },
          { text: this.$t('device_name'), value: "device_name", type: "keyword" },
          {
            text: `${this.$t('device')} OS`,
            value: "user_os",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              // { text: "UNKNOWN", value: "0" },
              { text: "Windows", value: "1" },
              // { text: "Linux", value: "2" },
              // { text: "OS_X", value: "3" },
              // { text: "Android", value: "4" },
              // { text: "iOS", value: "5" },
            ],
          },
          { text:  `${this.$t('device')} IP`, value: "ip", type: "keyword" },
          { text: this.$t('manager_name'), value: "manager_device_name", type: "keyword" },
          {
            text: `${this.$t('manager_str')} OS`,
            value: "manager_os",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              // { text: "UNKNOWN", value: "0" },
              { text: "Windows", value: "1" },
              // { text: "Linux", value: "2" },
              // { text: "OS_X", value: "3" },
              { text: "Android", value: "4" },
              // { text: "iOS", value: "5" },
            ],
          },
          { text: `${this.$t('manager_str')} IP`, value: "manager_pri_ip", type: "keyword" },
          {
            text: this.$t('recording'),
            value: "record_file_path",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: "O", value: "1" },
              { text: "X", value: "0" },
            ],
          },
          { text: this.$t('pledge_version'), value: "security_agreement_version", type: "keyword" },
          { text: this.$t('error_code'), value: "sl_error_code", type: "keyword" },
          { text: this.$t('application_reason'), value: "reason", type: "keyword" },
        ],
      },
      excelLoaded: false,
      excelLink: null,

      allSelected: false,
      allChecked: [],

      tableData: {
        fields: [
          { key: "requester_id", label: this.$t('ID'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "requester_name", label: this.$t('account-manage'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "start_time", label: this.$t('start_datetime'), sortable: true, thStyle: { minWidth: "130px" }, tdClass: "text-nowrap" },
          { key: "end_time", label: this.$t('end_datetime'), sortable: true, thStyle: { minWidth: "130px" }, tdClass: "text-nowrap" },
          { key: "device_name", label: this.$t('remote_device_name'), sortable: true, thStyle: { minWidth: "170px" }, tdClass: "text-nowrap" },
          { key: "user_os", label: `${this.$t('remote_device')} OS`, sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "ip", label: `${this.$t('remote_device')} IP`, sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "manager_device_name", label: this.$t('manager_name'), sortable: true, thStyle: { minWidth: "170px" }, tdClass: "text-nowrap" },
          { key: "manager_os", label: `${this.$t('manager_str')} OS`, sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "manager_pri_ip", label: `${this.$t('manager_str')} IP`, sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "record_file_path", label: this.$t('recording'), sortable: true, thStyle: { minWidth: "90px" }, tdClass: "text-nowrap" },
          { key: "flag_security_agreement", label: this.$t('pledge'), sortable: true, thStyle: { minWidth: "90px" }, tdClass: "text-nowrap" },
          { key: "security_agreement_version", label: this.$t('pledge_version'), sortable: true, thStyle: { minWidth: "110px" }, tdClass: "text-nowrap" },
          { key: "sl_error_code", label: this.$t('error_code'), sortable: true, thStyle: { minWidth: "110px" }, tdClass: "text-nowrap" },
          { key: "reason", label: this.$t('application_reason'), sortable: true, thStyle: { minWidth: "200px" }, tdClass: "text-nowrap" },
        ],
        list: [],
        pagination: {
          by: "start_time",
          limit: 24,
          offset: 0,
          order: "desc",
          export_id: "remoteHistoryTable",

          date_type: "start_time",
          start_date: "2023-08-30",
          end_date: "2023-09-12",

          request_type: 2,

          search_key: "",
          search_value: "",
          search_mode: "pagination",

          total: 1,
          current: 1,
          perOptions: [
            { value: 12, text: "12" },
            { value: 24, text: "24" },
            { value: 36, text: "36" },
          ],
        },
      },
    }
  },
  mounted() {
    this.tableData.pagination.start_date = moment(this.range.start).format("YYYY-MM-DD")
    this.tableData.pagination.end_date = moment(this.range.end).format("YYYY-MM-DD")
    this.fetchContract()
  },
  methods: {
    openContract(item) {
      this.contractForm = {
        security_agreement_version: item.security_agreement_version,
        content: _.find(this.contractList, { security_agreement_version: item.security_agreement_version }).content,
      }
      this.showContract = true
    },
    fetchContract() {
      SecurityAgreementAPI.get().then(res => {
        const { data } = res
        this.contractList = data.objects
      })
    },
    fetchList(ctx) {
      if (ctx.sortBy === "") return

      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit

      const params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,
        export_id: this.tableData.pagination.export_id,

        start_date: this.tableData.pagination.start_date,
        end_date: this.tableData.pagination.end_date,

        request_type: this.tableData.pagination.request_type,

        date_type: this.tableData.pagination.date_type,
        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",
      }

      return ManagementAPI.management.get("remote_control", { params }).then(res => {
        const { objects, meta, status } = res.data
        if (status !== 200) {
          this.$awn.warning(String(this.$awn.warning(this.$t('toasts_message.data_fetch_failed'))))
          return []
        }
        this.tableData.list = objects
        this.tableData.pagination.total = meta.total_count

        return this.tableData.list
      })
    },
    async downloadExcel() {
      this.excelLoaded = true
      const params = await this.fetchExcel()
      .then(params=>
      {
        //전송용 임시 폼 엘리먼트 생성
        var form = document.createElement('form');
        form.method = 'post';
        form.action = "/download/excel.html"; // /download/excel.html을 통해 DownloadExcelFileAPI호출

        // 엑셀 생성에 필요한 필터된 데이터를 폼에 추가
        let jsonData = {...params, language: this.$i18n.locale}
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'jsondata';
        input.value = JSON.stringify(jsonData);
        form.appendChild(input);

        // body에 폼 추가 및 제출 그 후 제거
        document.body.appendChild(form);
        form.target = '_blank';
        form.submit();
        document.body.removeChild(form);

        this.excelLoaded = false
      })
      .catch(err => {
        this.excelLoaded = false
        alert(String(this.$t('toasts_message.no_data_to_download_excel')))
      })
    },

    async fetchExcel() {
      let params = {
        by: this.tableData.pagination.by,
        limit: 0,
        offset: 0,
        order: this.tableData.pagination.order,
        export_id: this.tableData.pagination.export_id,

        start_date: this.tableData.pagination.start_date,
        end_date: this.tableData.pagination.end_date,

        request_type: this.tableData.pagination.request_type,

        date_type: this.tableData.pagination.date_type,
        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",
      }

      if (this.tableData.pagination.total < 1) {
        throw new Error(String(this.$t('no_data_available')))
      }
      const list = await ManagementAPI.management.get("remote_control", { params })
      
      
      const excelParams = list.data
      const { data } = await GetMgridAPI.get("")
      const excelParams_for_download = {
        api: excelParams.api,
        excel_doc_title: "",
        pagename: "",
        mgrid: data.objects.mgrid,
        objects: this.downloaded_excel_data_form(excelParams.objects),
      }
      excelParams_for_download.pagename = "userremote_controlhistory"
      excelParams_for_download.excel_doc_title = this.$t('management_page.user_remote_control_history')
      
      return excelParams_for_download;
    },
    downloaded_excel_data_form(input) {
      let originalLocale = this.$i18n.locale
      this.$i18n.locale = "ko"
      
      //input = excelParams.objects
      let output = []
      let record_file_path = {
        "1": "O",
        "0": "X",
      }
      for (let index = 0; index < input.length; index++) {
        let obj = {
          [this.$t('ID')]: input[index]["requester_id"],
          [this.$t('account-manage')]: input[index]["requester_name"],
          [this.$t('start_date_str')]: this.Date_time_split(input[index]["start_time"])[0],
          [this.$t('start_time')]: this.Date_time_split(input[index]["start_time"])[1],
          [this.$t('end_date')]: this.Date_time_split(input[index]["end_time"])[0],
          [this.$t('end_time')]: this.Date_time_split(input[index]["end_time"])[1],
          [this.$t('remote_device')]: input[index]["device_name"],
          [`${this.$t('remote_device')} OS`]: input[index]["user_os"],
          [`${this.$t('remote_device')} IP`]: input[index]["ip"],
          [this.$t('manager_str')]: input[index]["manager_device_name"],
          [`${this.$t('manager_str')} OS`]: input[index]["manager_os"],
          [`${this.$t('manager_str')} IP`]: input[index]["manager_pri_ip"],
          [this.$t('recording')]: input[index]["flag_auto_record"],
          [this.$t('pledge')]: input[index]["flag_security_agreement"],
          [this.$t('pledge_version')]: input[index]["security_agreement_version"],
          [this.$t('error_code')]: input[index]["sl_error_code"],
          [this.$t('application_reason')]: input[index]["reason"],
        }
        let obj2 = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, this.nullcheck(value)]))
        output.push(obj2)
      }
      this.$i18n.locale = originalLocale
      return output
    },
    nullcheck(input) {
      return input == null ? "-" : input
    },
    filter_record_file_path(input)
    {
      return input == null ? "X" : "O"
    },
    Date_time_split(input) {
      let return_array = []
      if (input != "-") {
        let input_array = input.split("T")
        return_array[0] = input_array[0]
        return_array[1] = input_array[1]
          .split(":")
          .slice(0, 2)
          .join(":")
      } else {
        return_array[0] = "-"
        return_array[1] = "-"
      }
      return return_array
    },

    changeSearchSelect() {
      if (this.selectInput.type === "select") {
        this.form.value = this.selectInput.list[0].value
      } else {
        this.form.value = ""
      }
    },

    openVideo(path) {
      window.open(`${this.AppState.Path.video}/${path}`, "_blank", "width=600, height=600")
    },

    search() {
      this.tableData.pagination.start_date = moment(this.range.start).format("YYYY-MM-DD")
      this.tableData.pagination.end_date = moment(this.range.end).format("YYYY-MM-DD")
      this.tableData.pagination.current = 1
      this.tableData.pagination.date_type = this.form.date_type
      this.tableData.pagination.search_key = this.form.search_key
      this.tableData.pagination.search_value = this.form.search_value
      this.$refs.userTable.refresh()
    },
  },
}
</script>

<style lang="scss" scoped></style>
